module.exports = __webpack_public_path__ + "img/referral-register-icon.d9dc24cd.svg";